import { render } from "./Domain.vue?vue&type=template&id=24b51400"
import script from "./Domain.vue?vue&type=script&lang=js"
export * from "./Domain.vue?vue&type=script&lang=js"

import exportComponent from "/builds/benoit67/django-business-center-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__